var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnviromental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6502 33.75C30.6402 33.75 30.6202 33.75 30.6102 33.75C30.2002 33.75 29.8602 33.41 29.8702 32.99C29.8702 32.58 30.2102 32.25 30.6202 32.25C30.6302 32.25 30.6502 32.25 30.6602 32.25C31.8002 32.25 32.8902 31.83 33.7302 31.05C35.2802 29.69 35.3902 27.75 34.9702 26.38C34.5502 25.01 33.3902 23.46 31.3602 23.2C31.0302 23.16 30.7702 22.91 30.7102 22.58C30.3102 20.19 29.0202 18.54 27.0802 17.94C25.0602 17.32 22.7302 17.93 21.2702 19.46C19.8502 20.95 19.5202 23.02 20.3402 25.31C20.4802 25.7 20.2802 26.13 19.8902 26.27C19.5002 26.41 19.0702 26.21 18.9302 25.82C17.9202 23.01 18.3802 20.32 20.1902 18.43C22.0402 16.5 24.9802 15.73 27.5302 16.52C29.8602 17.24 31.5102 19.16 32.1002 21.82C34.1402 22.28 35.7702 23.82 36.4202 25.95C37.1302 28.27 36.4802 30.65 34.7502 32.17C33.6102 33.19 32.1602 33.75 30.6502 33.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5701 33.75C19.5501 33.75 19.5301 33.75 19.5201 33.75C16.6401 33.55 15.3301 31.29 15.3301 29.28C15.3301 27.27 16.6401 25.02 19.5201 24.81C20.2601 24.8 20.9901 24.97 21.6301 25.29C22.0001 25.48 22.1401 25.93 21.9601 26.3C21.7701 26.67 21.3201 26.81 20.9501 26.63C20.5301 26.41 20.0501 26.32 19.5901 26.31C17.7001 26.45 16.8401 27.9 16.8401 29.28C16.8401 30.66 17.7001 32.11 19.6401 32.25C20.0501 32.28 20.3601 32.64 20.3301 33.05C20.2901 33.45 19.9601 33.75 19.5701 33.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8201 23.64C29.5501 23.64 29.2801 23.49 29.1501 23.22C28.9601 22.85 29.1101 22.4 29.4901 22.21C30.1001 21.9 30.7901 21.73 31.4701 21.72C31.8501 21.74 32.2301 22.04 32.2301 22.46C32.2401 22.87 31.9101 23.22 31.4901 23.22C31.0301 23.23 30.5701 23.34 30.1501 23.55C30.0501 23.62 29.9301 23.64 29.8201 23.64Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9702 35.7499C21.7802 35.7499 21.5902 35.6799 21.4402 35.5299C21.1502 35.2399 21.1502 34.7599 21.4402 34.4699L23.4402 32.4699C23.7302 32.1799 24.2102 32.1799 24.5002 32.4699C24.7902 32.7599 24.7902 33.2399 24.5002 33.5299L22.5002 35.5299C22.3602 35.6799 22.1702 35.7499 21.9702 35.7499Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9702 35.7499C25.7802 35.7499 25.5902 35.6799 25.4402 35.5299C25.1502 35.2399 25.1502 34.7599 25.4402 34.4699L27.4402 32.4699C27.7302 32.1799 28.2102 32.1799 28.5002 32.4699C28.7902 32.7599 28.7902 33.2399 28.5002 33.5299L26.5002 35.5299C26.3602 35.6799 26.1702 35.7499 25.9702 35.7499Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9702 31.7499C25.7802 31.7499 25.5902 31.6799 25.4402 31.5299C25.1502 31.2399 25.1502 30.7599 25.4402 30.4699L27.4402 28.4699C27.7302 28.1799 28.2102 28.1799 28.5002 28.4699C28.7902 28.7599 28.7902 29.2399 28.5002 29.5299L26.5002 31.5299C26.3602 31.6799 26.1702 31.7499 25.9702 31.7499Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9702 31.7499C21.7802 31.7499 21.5902 31.6799 21.4402 31.5299C21.1502 31.2399 21.1502 30.7599 21.4402 30.4699L23.4402 28.4699C23.7302 28.1799 24.2102 28.1799 24.5002 28.4699C24.7902 28.7599 24.7902 29.2399 24.5002 29.5299L22.5002 31.5299C22.3602 31.6799 22.1702 31.7499 21.9702 31.7499Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviromental);
export default __webpack_public_path__ + "static/media/enviromental.f2f036fb9a68b196453bba03c4cd782e.svg";
export { ForwardRef as ReactComponent };